import React from 'react';
import { Alert, Button } from '@mui/material';
import { useSecurityOperationContext } from '../../context/SecurityOperationContext';

export default function WatchlistPublicationRecoveryNotice() {
    const { publicationState, retryClientPublication } = useSecurityOperationContext();
    if (publicationState?.lifecycle !== 'needs_attention') return null;
    return (
        <Alert severity="error" sx={{ mb: 0.75 }}
            action={publicationState.canRetry && typeof retryClientPublication === 'function' ? (
                <Button color="inherit" size="small"
                    onClick={() => retryClientPublication(publicationState)}>
                    Retry refreshing
                </Button>
            ) : null}>
            The app could not finish refreshing this Watchlist. The previous data is still shown.
        </Alert>
    );
}
